let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g307a")).then(() => parcelRequire('6VRE3'));